ACC.productlisting = {

	currentPage:             0,
	numberOfPages:           Number.MAX_VALUE,
	showMoreResultsArea:    $('#footer'),
	baseQuery:               $("#resultsList").attr("data-current-query")   || "",
	isOrderForm:             $("#resultsList").attr("data-isOrderForm")      || false,
	isOnlyProductIds:        $("#resultsList").attr("data-isOnlyProductIds") || false,
	searchPath:			 	 $("#resultsList").attr("data-current-path"),
    onlyOnStock:             $("#resultsList").attr("data-onlyOnStock"),
    isCreateOrderForm:		 $("#isCreateOrderForm").val() || false,
	lastDataHtml:			 "",
	inCall: false,
	infiniteScrollingSessionStorageTimeframe : 1800000, // or 30 minutes

	triggerLoadMoreResults: function() {
		if (ACC.productlisting.currentPage < ACC.productlisting.numberOfPages) {
			// show the page loader
			ACC.common.showSpinnerById('spinner');
			ACC.productlisting.loadMoreResults(parseInt(ACC.productlisting.currentPage) + 1);
		}
	},
    initPageEvents: function () {
		$(".qty").on('change', function(event) {
  			var input = $(event.target);
  			var selected =input.find('option:selected');
		  	var priceValue = selected.data("price");

  			var form = input.parent();
  			var sku = form.find("#productCodePost").val();
  			var priceFieldName = "#priceValue"+sku;
  			var priceField = $(document).find(priceFieldName);
  			priceField.html(priceValue);
		});
	},

	loadMoreResults: function(page) {
		skuIndex = "0";

		if ($("#skuIndexSavedValue").attr("data-sku-index") !== undefined) {
			skuIndex = $("#skuIndexSavedValue").attr("data-sku-index");
		}

		searchResultType = $("[name='searchResultType']:radio:checked").val() || "";

		if(ACC.productlisting.inCall == false) {
			ACC.productlisting.inCall = true;
			$.ajax({
				url: ACC.productlisting.searchPath + "/results?query=" + encodeURI(ACC.productlisting.baseQuery) + "&page=" + page + "&isOnlyProductIds=" + ACC.productlisting.isOnlyProductIds +
					"&isOrderForm=" + ACC.productlisting.isOrderForm + "&skuIndex=" + skuIndex + "&isCreateOrderForm=" + ACC.productlisting.isCreateOrderForm + "&searchResultType=" + searchResultType,
					success: function (data) {
						if (data.pagination !== undefined) {
							if ($("#resultsList").length > 0 && ACC.productlisting.lastDataHtml !== data.productListerHtml) { //Product List Page
								ACC.productlisting.lastDataHtml = data.productListerHtml;
								$("#resultsList").append('<a id="page_' + data.pagination.currentPage + '"></a>');
								$("#resultsList").append(data.productListerHtml);
								// rebind the add-to-cart ajaxForms
								ACC.product.bindToAddToCartForm({enforce: true});
								if ($("#skuIndexSavedValue").attr("data-sku-index") !== undefined){
									$("#skuIndexSavedValue").attr("data-sku-index", data.skuIndex);
								}
							}

							ACC.productlisting.inCall = false;
							ACC.productlisting.updatePaginationInfos(data.pagination);
							ACC.common.hideSpinnerById('spinner');
							ACC.productlisting.showMoreResultsArea.waypoint({
							    handler: function() {;},
                                offset: '100%'
							}); // reconfigure waypoint eventhandler
						}
						else {
							ACC.common.hideSpinner();
						}
						ACC.productlisting.inCall = false;
					},
					error: function (request, status, error) {
				        console.log("productListingError (loadMoreResults):  " + error);
						ACC.productlisting.inCall = false;
					}
			});
		}

	},

	updatePaginationInfos: function(paginationInfo) {
		ACC.productlisting.currentPage   = parseInt(paginationInfo.currentPage);
		ACC.productlisting.numberOfPages = parseInt(paginationInfo.numberOfPages);
		var currentPageFromStorage = ACC.productlisting.loadPageFromSessionStorage();
		if (currentPageFromStorage > ACC.productlisting.currentPage) {
			ACC.productlisting.triggerLoadMoreResults();
		}
		else if (currentPageFromStorage == ACC.productlisting.currentPage) {
			// in this case, we need to scroll to the last loaded page (using the ancor added in the success event of the ajax-call
			if ($("#page_" + currentPageFromStorage) && $("#page_" + currentPageFromStorage).length > 0) {
				$("#page_" + currentPageFromStorage).first().scrollIntoView();
			}
		}
		else {
			ACC.productlisting.storePageInSessionStorage(ACC.productlisting.currentPage);
		}
	},

	bindSortingSelector: function() {
		$('#sort_form1, #sort_form2').change(function() {
			$(this).trigger('submit');
		});
	},

	initialize: function() {
		if ($('.js-product-listing-page').length <= 0) {
			return;
		}

		with(ACC.productlisting) {
			bindSortingSelector();
			initPageEvents();
			verifyCurrentPage();
		}
	},

	getCurrentSessionStorageTimeframe : function() {
		var myTime = new Date().getTime();
		var mod = myTime % ACC.productlisting.infiniteScrollingSessionStorageTimeframe;
		var timeframe = myTime - mod;
		return timeframe;
	},

	storePageInSessionStorage: function(page) {
		var sessionStorage = window.sessionStorage;
		// store page number in the sessionStorage using a time window (1 800 000 ms - 0,5h)
		var timeframe = ACC.productlisting.getCurrentSessionStorageTimeframe();
		// Save data to sessionStorage
		sessionStorage.setItem(location.href + '_' + timeframe, page);
	},

	loadPageFromSessionStorage: function() {
		var sessionStorage = window.sessionStorage;
		// load page number from sessionStorage using a time window (1 800 000 ms - 0,5h)
		var timeframe = ACC.productlisting.getCurrentSessionStorageTimeframe();
		// get item form session storage
		var data = sessionStorage.getItem(location.href + '_' + timeframe);
		if (!data || data === '') {
			return 0;
		}
        return parseInt(data) || 0;
	},

	verifyCurrentPage: function() {
		var currentPageFromStorage = ACC.productlisting.loadPageFromSessionStorage();
		if (currentPageFromStorage > ACC.productlisting.currentPage) {
			ACC.productlisting.triggerLoadMoreResults();
		}
	}

};

$(document).ready(function() {
	ACC.productlisting.initialize();
});